import script from "./JobDesign.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDesign.vue?vue&type=script&setup=true&lang=js"

import "./JobDesign.vue?vue&type=style&index=0&id=2e77228d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e77228d"]])

export default __exports__